<template>
  <div class="classification-report-tbl">
    <v-data-table
      :headers="table.headers"
      :items="reportLayout.dataSeriesTbl"
      :items-per-page="pagination.itemsPerPage"
      @pagination="PAGINATION = $event"
      :page.sync="pagination.page"
      :loading="table.loading"
      :loading-text="$t('tableText.loadingText')"
      class="elevation-1 mt-1"
      :no-results-text="$t('tableText.noResultsText')"
      :no-data-text="$t('tableText.noDataText')"
      hide-default-header
      hide-default-footer
      fixed-header
      dense
    >
      <template v-slot:item="{ item, index }" style="overflow-y: auto">
        <tr style="cursor: grabbing">
          <td v-if="isDataRow(index)" class="b-1-g text-center mw-50">
            {{ index + 1 }}
          </td>
          <td
            v-if="isDataRow(index)"
            class="text-center b-1-g mw-100"
            style="text-decoration: none; color: #55a1ec; cursor: pointer"
            @click="openPopupReportByMajor(item)"
          >
            {{ item.majorCode }}
          </td>
          <td v-if="isDataRow(index)" class="b-1-g mw-145">
            {{ item.majorNameKanji }}
          </td>

          <td v-else class="b-1-g text-center" colspan="3">合計、平均</td>

          <td class="text-right b-1-g mw-145" v-show="isOrderQuantity">
            {{ formatNumber(item.orderQuantity) }}
          </td>
          <td class="text-right b-1-g mw-145" v-show="isOrderQuantity">
            {{ formatNumber(item.orderQuantityCompare) }}
          </td>
          <td class="text-right b-1-g mw-70" v-show="isOrderQuantity">
            {{
              getPercentIncrease(item.orderQuantity, item.orderQuantityCompare)
            }}
          </td>

          <!-- total price -->
          <td class="text-right b-1-g mw-145" v-show="isTotalPrice">
            {{ formatNumber(item.totalPrice) }}
          </td>
          <td class="text-right b-1-g mw-145" v-show="isTotalPrice">
            {{ formatNumber(item.totalPriceCompare) }}
          </td>
          <td class="text-right b-1-g mw-70" v-show="isTotalPrice">
            {{ getPercentIncrease(item.totalPrice, item.totalPriceCompare) }}
          </td>

          <!-- totalSaleMoney -->
          <td class="text-right b-1-g mw-145" v-show="isTotalSaleMoney">
            {{ formatNumber(item.totalSaleMoney) }}
          </td>
          <td class="text-right b-1-g mw-145" v-show="isTotalSaleMoney">
            {{ formatNumber(item.totalSaleMoneyCompare) }}
          </td>
          <td class="text-right b-1-g mw-70" v-show="isTotalSaleMoney">
            {{
              getPercentIncrease(
                item.totalSaleMoney,
                item.totalSaleMoneyCompare,
              )
            }}
          </td>

          <!-- cancelOrderAmount -->
          <td class="text-right b-1-g mw-145" v-show="isCancelOrderAmount">
            {{ formatNumber(item.cancelOrderAmount) }}
          </td>
          <td class="text-right b-1-g mw-145" v-show="isCancelOrderAmount">
            {{ formatNumber(item.cancelOrderAmountCompare) }}
          </td>
          <td class="text-right b-1-g mw-70" v-show="isCancelOrderAmount">
            {{
              getPercentIncrease(
                item.cancelOrderAmount,
                item.cancelOrderAmountCompare,
              )
            }}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        <td colspan="12" class="text-center">
          {{ $t("tableText.noDataText") }}
        </td>
      </template>
      <template v-slot:header="{ props }" v-if="table.headers.length > 0">
        <thead class="border-header-tbl">
          <tr>
            <th
              v-for="(header, idx) in props.headers"
              :idx="`sup-header-${idx}`"
              :key="`key-header-${idx}`"
              :rowspan="header.rowSpans"
              :colspan="header.colSpans"
            >
              {{ header.text }}
            </th>
          </tr>

          <tr>
            <th
              v-for="(subHeader, idx) in table.subHeaders"
              :idx="`sub-header-${idx}`"
              :key="`key-sub-header-${idx}`"
              rowspan="1"
              colspan="1"
            >
              {{ subHeader.text }}
            </th>
          </tr>
        </thead>
      </template>
      <template v-slot:footer> </template>
    </v-data-table>
    <v-row v-if="classificationMiddleData.show">
      <v-col cols="12">
        <div class="pre-title mt-8 ml-0">
          <span
            >{{ $t("label.middleCategory") }} :
            {{ classificationMiddleData.majorCode }}</span
          >
        </div>
      </v-col>
    </v-row>
    <v-row v-if="classificationMiddleData.show">
      <v-col cols="12">
        <classification-report-tbl-middle
          id="tbl-middle-category"
          :reportLayout="classificationMiddleData.reportLayout"
          :pagination="classificationMiddleData.pagination"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { PAGINATION, getClassificationHeaders } from "@/common/constant";
import TableFooter from "@/components/common/TableFooter.vue";
import {
  getJPDateFormat,
  getFieldNameChartById,
  getPercentIncrease,
  CLASSIFICATION_DISPLAY_ITEM_VALUES,
  formatNumber,
} from "@/common/constant";
import PopupReportTblByMajor from "@/components/report/PopupReportTblByMajor";
import { GET_CLASSIFICATION_REPORT_DATA_BY_MAJOR_CATEGORY } from "@/api/report";
import ClassificationReportTblMiddle from "@/components/report/ClassificationReportTblMiddle.vue";
import { scroll2BottomByElementId } from "@/common/common-function";

export default {
  name: "ClassificationReportTbl",
  components: {
    PopupReportTblByMajor,
    TableFooter,
    ClassificationReportTblMiddle,
  },
  props: {
    request: {
      type: Object,
      require: true,
    },
    reportLayout: {
      type: Object,
      require: true,
    },
    pagination: {
      type: Object,
      require: true,
    },
    selectedDate: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      PAGINATION: PAGINATION,
      getClassificationHeaders,
      getJPDateFormat: getJPDateFormat,
      getFieldNameChartById: getFieldNameChartById,
      getPercentIncrease: getPercentIncrease,
      CLASSIFICATION_DISPLAY_ITEM_VALUES,
      formatNumber,
      table: {
        headers: [],
        subHeaders: [],
        items: [],
        loading: false,
        count: 0,
      },
      showPopup: false,
      reportByMajorResquest: {
        middleCodes: [],
        storeCode: null,
        displayItems: [],
        referenceDate: null,
        compareDate: null,
        majorNameKanji: null,
        majorCode: null,
      },
      classificationMiddleData: {
        majorCode: "",
        show: false,
        pagination: {},
        reportLayout: {},
      },
      scroll2BottomByElementId,
    };
  },
  computed: {
    isOrderQuantity() {
      return (
        this.reportLayout.reportIds &&
        this.reportLayout.reportIds.includes(
          CLASSIFICATION_DISPLAY_ITEM_VALUES[0].value,
        )
      );
    },
    isTotalPrice() {
      return (
        this.reportLayout.reportIds &&
        this.reportLayout.reportIds.includes(
          CLASSIFICATION_DISPLAY_ITEM_VALUES[1].value,
        )
      );
    },
    isTotalSaleMoney() {
      return (
        this.reportLayout.reportIds &&
        this.reportLayout.reportIds.includes(
          CLASSIFICATION_DISPLAY_ITEM_VALUES[2].value,
        )
      );
    },
    isCancelOrderAmount() {
      return (
        this.reportLayout.reportIds &&
        this.reportLayout.reportIds.includes(
          CLASSIFICATION_DISPLAY_ITEM_VALUES[3].value,
        )
      );
    },
  },
  methods: {
    fetchData() {},
    getCustomHeaders() {
      this.table.headers = getClassificationHeaders(
        [1],
        this.reportLayout.reportIds,
      );

      this.reportLayout.reportIds.forEach((id) => {
        this.table.subHeaders.push({
          text: getJPDateFormat(this.reportLayout.selectedReportDate, "-"),
          value: "orderQuantity1",
        });
        this.table.subHeaders.push({
          text: getJPDateFormat(this.reportLayout.compareReportDate, "-"),
          value: "orderQuantityCompare1",
        });
        this.table.subHeaders.push({
          text: "昨対",
        });
      });
    },
    isDataRow(index) {
      return index < this.reportLayout.dataSeriesTbl.length - 1;
    },
    async openPopupReportByMajor(item) {
      try {
        let requestM = { ...this.request };
        requestM.referenceDate = this.selectedDate.referenceDate;
        requestM.compareDate = this.selectedDate.compareDate;
        requestM.majorCode = item.majorCode;
        this.classificationMiddleData.majorCode = item.majorCode;
        let { data } = await GET_CLASSIFICATION_REPORT_DATA_BY_MAJOR_CATEGORY(
          requestM,
        );
        if (data) {
          this.updateDataSeries(data);
        }
        this.classificationMiddleData.show = true;
        this.scroll2BottomByElementId("tbl-middle-category");
      } catch (error) {
        console.log(error);
      }
    },
    updateDataSeries({ responseList }) {
      this.classificationMiddleData.pagination = { ...this.pagination };
      this.classificationMiddleData.reportLayout = { ...this.reportLayout };
      this.classificationMiddleData.reportLayout.dataSeriesTbl = [
        ...responseList,
      ];
      this.classificationMiddleData.reportLayout.count =
        this.reportLayout.dataSeriesTbl.count;

      let compounndRowData = {
        orderQuantity: 0,
        orderQuantityCompare: 0,
        totalPrice: 0,
        totalPriceCompare: 0,
        totalSaleMoney: 0,
        totalSaleMoneyCompare: 0,
        cancelOrderAmount: 0,
        cancelOrderAmountCompare: 0,
      };
      if (responseList && responseList.length > 0) {
        responseList.forEach((item) => {
          compounndRowData.orderQuantity += item.orderQuantity;
          compounndRowData.orderQuantityCompare += item.orderQuantityCompare;
          compounndRowData.totalPrice += item.totalPrice;
          compounndRowData.totalPriceCompare += item.totalPriceCompare;
          compounndRowData.totalSaleMoney += item.totalSaleMoney;
          compounndRowData.totalSaleMoneyCompare += item.totalSaleMoneyCompare;
          compounndRowData.cancelOrderAmount += item.cancelOrderAmount;
          compounndRowData.cancelOrderAmountCompare +=
            item.cancelOrderAmountCompare;
        });
      }
      this.classificationMiddleData.reportLayout.dataSeriesTbl.push(
        compounndRowData,
      );
      this.classificationMiddleData.pagination.itemsPerPage =
        responseList.length + 1;
    },
  },
  created() {
    this.getCustomHeaders();
  },
  mounted() {},
};
</script>

<style lang="scss">
.classification-report-tbl {
  .border-header-tbl {
    th {
      border: 0.2px solid rgba(255, 255, 255, 0.5) !important;
      text-align: center !important;
      background: #1976d2 !important;
      color: white !important;
    }
  }
  .b-1-g {
    border-right: 1px solid #d9dedb !important;
  }
  .v-data-table__wrapper {
    width: calc(100vw - 118px) !important;
  }

  @media only screen and (max-width: 800px) {
    .v-data-table__wrapper {
      width: calc(100vw - 5px) !important;
    }
  }
  .custom-dialog .v-toolbar__content {
    margin-left: 200px !important;
  }
}
</style>
